import { css as t } from "@microsoft/fast-element";
import { normalize as o } from "../common/normalize.js";
import { display as a } from "@matrix42/fast-foundation";
import { typography as r } from "../styles/typography.js";
import { designTokens as e } from "../design-tokens.js";
const c = t`
  ${o}
  ${a("flex")}
    .control {
    /* Base */
    display: flex;
    /* Layout */
    gap: ${e.spacing[12]};
    /* Typography */
    ${r("p", "regular")}
  }

  .rows {
    /* Base */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .rows-per-page {
    /* Layout */
    display: flex;
    padding: ${e.spacing["2.5"]} ${e.spacing[2]}
      ${e.spacing["2.5"]} 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* Style */
    text-align: center;
    color: ${e.color.neutral[300]};
    /* Typography */
    ${r("p", "regular", !0)}
  }
`;
export {
  c as tablePaginationStyles
};
